import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const links = [{
  label: 'Browse tasks',
  href: '#briefs'
}, {
  label: 'For companies',
  href: '#how'
}, {
  label: 'How it works',
  href: '#how'
}, {
  label: 'Coverage',
  href: '#coverage'
}];
export function Nav() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line bg-canvas/90 backdrop-blur" data-id="element-213" data-mp="1fyw24ayfact5">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6" aria-label="Main" data-id="element-214" data-mp="1kxh70nomdknx">
        <div className="flex items-center gap-10" data-id="element-215" data-mp="1pqtgtron3mwm">
          <Logo data-id="element-216" data-mp="1uobtnt5s2m9w" />
          <ul className="hidden items-center gap-7 md:flex" data-id="element-217" data-mp="1up3goflb7bok">
            {links.map(link => <li key={link.label} data-id="element-218" data-mp="1yqovw7lbg21x">
                <a href={link.href} className="whitespace-nowrap text-sm text-muted transition-colors duration-150 hover:text-ink" data-id="element-219" data-mp="1yrrpina0wilj">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </div>
        <div className="hidden items-center gap-5 md:flex" data-id="element-220" data-mp="1u2s8hq8hsldl">
          <a href="#" className="text-sm text-muted transition-colors duration-150 hover:text-ink" data-id="element-221" data-mp="1p4qq77iw4q36">
            Sign in
          </a>
          <a href="#start" className="whitespace-nowrap rounded-full bg-ink px-4 py-2 text-sm font-medium text-canvas transition-opacity duration-150 hover:opacity-85" data-id="element-222" data-mp="1k7qiks6e7f9y">
            Start for free
          </a>
        </div>
        <button type="button" className="rounded-md p-2 md:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} onClick={() => setOpen(v => !v)} data-id="element-223" data-mp="283utdznr3pmx">
          {open ? <XIcon className="h-5 w-5" data-id="element-224" data-mp="30l76f329rar3" /> : <MenuIcon className="h-5 w-5" data-id="element-225" data-mp="30m8ldimeohe3" />}
        </button>
      </nav>
      <AnimatePresence data-id="element-226" data-mp="2vs4dmx5bg5by">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-canvas px-6 py-4 md:hidden" data-id="element-227" data-mp="tw5carq057i5">
            <ul className="flex flex-col gap-1" data-id="element-228" data-mp="p56rpfxzdn93">
              {links.map(link => <li key={link.label} data-id="element-229" data-mp="a85y16w8bi7z">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-2 text-base" data-id="element-230" data-mp="a74j2rc3ebkz">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-4 flex gap-3" data-id="element-231" data-mp="18susvyp7pvp">
              <a href="#" className="flex-1 rounded-full border border-line py-2.5 text-center text-sm font-medium" data-id="element-232" data-mp="66kr026dly5p">
                Sign in
              </a>
              <a href="#start" className="flex-1 rounded-full bg-ink py-2.5 text-center text-sm font-medium text-canvas" data-id="element-233" data-mp="1vm1y260nif5i">
                Start for free
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}